<template>
  <div>
    <LoaderMaskComponent v-if="lyLoading"/>
    <div v-else>
      <div class="d_flex_btwn">
        <h1 class="common_title">Customer details</h1>
        <router-link :to="{name: 'customers'}" class="btn btn_black">Back to List</router-link>
      </div>
      <div class="ticket_contact_list_details_page ">
        <div class="ticket_contact_list_details_page_wrap ">
          <div class="ticket_contact_list_details_left width_full">
            <div class="ticket_contact_list_details_left_wrap">
              <div class="ticket_contact_list_details_table_wrap">
                <div class="contact_details_heading_wrap">
                  <div class="contact_details_heading_inner width_full d_flex_btwn">
                    <div class="contact_details_heading">
                      <div class="img">
                        <img :src="customer?.profile_image" alt="">
                      </div>
                      <div class="text">
                        <h2>
                          <span class="mr_10">{{ customer?.name }}</span>
                          <button type="button" class="btn btn_sm btn_info" v-if="customer?.user_id">Sub account</button>
                          <button type="button" class="btn btn_sm btn_success" v-else>Root account</button>
                        </h2>
                        <p>
                          <router-link :to="`/company/${customer?.company_id}/show`">{{
                              customer?.company_name
                            }}
                          </router-link>
                        </p>
                        <p>{{ customer?.email }}</p>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="contact_details_content" style="background: transparent">
                  <nav class="tabs">
                    <ul class="">
                      <li href="#tab1" :class="{'active' : activeTab === 'activityList'}"
                          @click="activeTab = 'activityList'">
                        Generated Bills
                      </li>
                      <li href="#tab2" :class="{'active' : activeTab === 'ticketList'}"
                          @click="activeTab = 'ticketList'">
                        Invoices
                      </li>
                      <li href="#tab2" :class="{'active' : activeTab === 'auditLogs'}"
                          @click="activeTab = 'auditLogs'">
                        Audit Logs
                      </li>
                    </ul>
                  </nav>
                  <div class="tab_content_wrapper">
                    <div id="tab1" class="tab_content" :class="{show : activeTab === 'activityList'}">
                      <div class="fadein">
                        <div class="contact_details_content_wrap p_0">
                          <ticket-table-component
                              :columns="columns"
                              :rows="billings"
                              :sortable="sortable"
                              :pagination="pagination"
                              @sorting="sorting"
                              @pageChanged="pageChanged">
                            <template v-slot:service_name="{row}">
                              {{ row?.cloudServerPrice?.cloud_server?.server_name }}
                              <!--                                            <span v-if="row?.cloudServerPrice?.cloud_disk_id">
                                                                            {{ row?.cloudServerPrice?.cloud_disk?.name }}
                                                                          </span>
                                                                          <span v-if="bill?.cloudServerPrice?.cloud_network_id">
                                                                            {{ row?.cloudServerPrice?.cloud_network?.public_ip }}
                                                                          </span>
                                                                          <span v-if="bill?.cloudServerPrice?.cloud_server_id">
                                                                            {{ row?.cloudServerPrice?.cloud_server?.host_name }}
                                                                          </span>-->
                            </template>
                            <template v-slot:action="{ row }">
                              <router-link
                                  :to="{name: 'view_customer_billing_details', params: {id: row.id, customer_id: row.customer_id, date: row.billing_date}}"
                                  class="btn btn_black mb_5">
                                Details
                              </router-link>
                            </template>
                          </ticket-table-component>
                        </div>
                        <top-pagination-component
                            :pagination="pagination"
                            @pageChanged="pageChanged"
                        />
                      </div>
                    </div>

                    <div id="tab2" class="tab_content" :class="{show : activeTab === 'ticketList'}">
                      <CustomerBillInvoiceList/>
                    </div>
                    <div id="tab3" class="tab_content" :class="{show : activeTab === 'auditLogs'}">
                      <CustomerAuditLogs />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TicketTableComponent from "@/components/shared/TicketTableComponent";
import TopPaginationComponent from '@/components/shared/TopPaginationComponent.vue';
import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";
import CustomerBillInvoiceList from "@/views/customers/CustomerBillInvoiceList.vue";
import CustomerAuditLogs from "@/views/customers/CustomerAuditLogs.vue";

export default {
  name: 'CustomerBillView',
  components: {
    CustomerAuditLogs,
    LoaderMaskComponent, TicketTableComponent, TopPaginationComponent, CustomerBillInvoiceList},
  data() {
    return {
      lyLoading: false,
      customer: null,
      activeTab: 'activityList',
      billings: [],
      tickets: [],
      invoices: [],
      filter: {
        server_region_id: '',
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'cloudService.name,subject,status',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      },
      sortable: {
        order: 'created_at',
        sort: 'desc'
      },
      columns: [
        {
          label: "Service",
          field: "cloud_service.name",
        },
        {
          label: "Server Name",
          field: "service_name",
          slot: true,
        },
        {
          label: "Service Type",
          field: "service_type",
          sortable: true,
        },
        {
          label: "Billing Type",
          field: "billing_type",
          sortable: true,
        },
        {
          label: "Amount",
          field: "formatted_total_amount",
          sortable: true,
        },
        {
          label: "Billing Month",
          field: "billing_date",
          sortable: true,
        },
        {
          label: "Status",
          field: "status",
          sortable: true,
        },
        {
          label: "Action",
          field: "action",
          sortable: false,
          slot: true,
        },
      ],
      pagination: null,
    }
  },
  watch: {
    $route(to, from) {
      if (to.name == from.name && !window._.isEqual(to, from)) {
        this.loadContactData()
        this.loadTimelineData()
      }
    },
  },
  created() {
    if (this.$route.params.id) {
      this.loadTimelineData()
      this.loadContactData()
    }
  },
  mounted() {
    this.ticketScrollbar()
  },
  methods: {
    searchQuery() {
      // A new search/filter changes the result set, so the old page number
      // no longer means anything — start from the first page.
      this.queryParams.page = 1;
      this.changeRoute();
    },
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute()
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute()
    },
    changeRoute() {
      this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
    },
    loadContactData() {
      this.lyLoading = true;
      this.axios.get('/customers/' + this.$route.params.id)
          .then(({data}) => {
            this.customer = data.data
          })
          .catch(() => {
            this.showFailMsg("No customer exists!");
          })
          .finally(() => {
            this.ticketScrollbar()
            this.lyLoading = false;
          })
    },
    loadTimelineData() {
      this.lyLoading = true;
      this.axios.get('/customer-billing/' + this.$route.params.id, {
        params: {...this.queryParams, ...this.filter}
      })
          .then(({data}) => {
            this.billings = data.data
          })
          .catch(() => {
            this.showFailMsg("No timeline exists!");
          })
          .finally(() => {
            this.lyLoading = false;
          })
    },
  }
}
</script>
<style scoped>

</style>
